import { ImageModel, ProviderModel } from "../../data/entities";
import { ProviderODataRepo, ProviderRepo } from "../../data/repo";
import { ImageRequest } from "../../models";
import { BaseEntityService } from "../BaseEntityService"

export class ProviderService extends BaseEntityService<ProviderModel, ProviderRepo, ProviderODataRepo> {
  constructor(){
    super(new ProviderRepo(), new ProviderODataRepo());
  }

  async getProvidersByUserIdAsync(): Promise<ProviderModel[]> {
    return await this.repo.getProvidersByUserIdAsync();
  }

  async getProvidersByLocationIdAsync(locationId: number): Promise<ProviderModel[]> {
    return await this.repo.getProvidersByLocationIdAsync(locationId);
  }

  async getByLocationService(locationId: number, serviceId: number): Promise<ProviderModel[]> {
    const providers = await this.repo.getByLocationService(locationId, serviceId);
    return providers || [];
  }

  async getAvailableTimeSlots(providerId: number | null, serviceId: number, date: Date): Promise<string[]> {
    const slots = await this.repo.getAvailableTimeSlots(providerId, serviceId, date);
    return slots || [];
  }

    async insertProfilePicture(request: ImageRequest): Promise<ImageModel> {
      return await this.repo.insertProfilePicture(request);
    }

    async deleteProfilePicture(id: number): Promise<boolean> {
      return await this.repo.deleteProfilePicture(id);
    }

}

export default ProviderService;
